import { ACCEPT_PAYMENTS } from '@/common/permissionConstants';
import { useFeatureFlags } from '@/composables/useFeatureFlags';

const featureFlagGuard = () => {
    const { isEnabled } = useFeatureFlags();
    if (!isEnabled('patient-ledger')) return { name: 'home' };
};

export default [
    {
        path: 'ledger',
        name: 'ledger',
        meta: {
            label: 'Patient ledger',
            hasPermission: ACCEPT_PAYMENTS,
        },
        component: () => import('@/views/LedgerOrchestrationPage.vue'),
        beforeEnter: featureFlagGuard,
    },
];
